import securityManager from "../../../services/managers/security";

export const onSelectedGranularityChange = (state, action) => {
  let chartWhiteboards = state.chartWhiteboards.slice();
  let whiteboard = { ...chartWhiteboards[action.payload.whiteboardIndex] };

  whiteboard.selectedGranularity = action.payload.code;
  whiteboard.__change_detection_key = securityManager.generateKey();
  chartWhiteboards[action.payload.whiteboardIndex] = whiteboard;

  return { ...state, chartWhiteboards };
};



// WEBPACK FOOTER //
// ./src/store/analytics/chart-granularity/action-handlers.js